import 'angular';

import { downgradeComponent, downgradeInjectable } from '@angular/upgrade/static';

import { VehicleVisualsCatalogComponent } from './vehicle-visuals.catalog.component';
import { VehicleVisualsService }          from './vehicle-visuals.service';

angular.module('app-lite.vehicle-visuals', [])
  .directive('worVehicleVisualsCatalog', downgradeComponent({ component: VehicleVisualsCatalogComponent }))
  .service('vehicleVisualsApi', downgradeInjectable(VehicleVisualsService));
